(() => {
  customElements.whenDefined('product-bundle-form').then(() => {
    if (customElements.get('codex-routine-form')) return;
    class CodexRoutineForm extends customElements.get('product-bundle-form') {
      connectedCallback() {
        if (this.dataset.routineReady) return;
        super.connectedCallback();
        this.dataset.routineReady = 'true';
        this.options.forEach(option => option.addEventListener('keydown', event => {
          if (['Enter', ' '].includes(event.key)) { event.preventDefault(); option.click(); }
          if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
            event.preventDefault();
            const options = [...this.options];
            const direction = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
            const next = options[(options.indexOf(option) + direction + options.length) % options.length];
            next.click(); next.focus();
          }
        }));
        this.querySelectorAll('[data-purchase]').forEach(card => {
          card.addEventListener('click', () => { this.dataset.buyMode = card.dataset.purchase; this._syncPurchase(); });
          card.addEventListener('keydown', event => {
            if (['Enter', ' '].includes(event.key)) { event.preventDefault(); card.click(); }
            if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
              event.preventDefault();
              const next = card.parentElement.querySelector(`[data-purchase="${card.dataset.purchase === 'once' ? 'subscription' : 'once'}"]`);
              next.click(); next.focus();
            }
          });
        });
        this._syncPurchase();
      }
      _setSelected(option) {
        super._setSelected(option);
        this._syncPurchase();
      }
      _syncPurchase() {
        const option = this._getSelectedOption();
        if (!option) return;
        const once = this.dataset.buyMode === 'once';
        this.options.forEach(item => {
          const selected = item === option;
          item.setAttribute('aria-checked', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('[data-routine-panel]').forEach(panel => {
          panel.hidden = panel.dataset.routinePanel !== option.dataset.variantId;
          panel.querySelectorAll('[data-purchase]').forEach(card => {
            const selected = card.dataset.purchase === (once ? 'once' : 'subscription');
            card.classList.toggle('selected', selected);
            card.setAttribute('aria-checked', String(selected));
            card.tabIndex = selected ? 0 : -1;
          });
        });
        if (this.addBtn) {
          this.addBtn.dataset.variantId = once ? option.dataset.oneTimeVariantId : option.dataset.variantId;
          this.addBtn.dataset.sellingPlanId = once ? '' : option.dataset.sellingPlanId;
          const available = once ? option.dataset.onceAvailable === 'true' : option.dataset.subAvailable === 'true';
          this.addBtn.disabled = !available;
          this.addBtn.querySelector('span').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        }
        const refill = this.querySelector('.js-cr-refill');
        const activePanel = this.querySelector('[data-routine-panel]:not([hidden])');
        if (refill && activePanel) refill.textContent = activePanel.dataset.refillLabel || '';
        this.closest('.cr-product')?.classList.toggle('cr-buy-once', once);
      }
      _onAddSubscriptionClick() {
        const option = this._getSelectedOption();
        if (!option || this.addBtn.disabled) return;
        const once = this.dataset.buyMode === 'once';
        const items = [{ variantId: once ? option.dataset.oneTimeVariantId : option.dataset.variantId, sellingPlanId: once ? null : option.dataset.sellingPlanId }];
        // Gift-eligible routines. SKU fallback covers Intelligems duplicate products (new variant IDs, same SKUs).
        const giftVariantIds = ['44669449994561', '51041094435137'];
        const giftSkus = ['FLKS_SUBBNDL_001', 'FLKS_NIGHTSHIFTBNDL_001'];
        if (!once && (giftVariantIds.includes(option.dataset.variantId) || giftSkus.includes(option.dataset.sku))) {
          items[0].properties = { [this.dataset.giftLabel]: this.dataset.giftValue };
        }
        if (this.travelCheckbox?.checked && this.travelCheckbox.dataset.variantId && !this.travelCheckbox.disabled) {
          items.push({ variantId: this.travelCheckbox.dataset.variantId, sellingPlanId: null });
        }
        const error = this.querySelector('.cr-error');
        error.hidden = true;
        this._setLoading(this.addBtn, true);
        this.addMultipleToCart(items).catch(() => {
          error.textContent = this.dataset.errorLabel;
          error.hidden = false;
        }).finally(() => { this._setLoading(this.addBtn, false); this._syncPurchase(); });
      }
    }
    customElements.define('codex-routine-form', CodexRoutineForm);
  });
})();
